/**
 * @generated SignedSource<<19703439fba9db21e060ec4b665aaef7>>
 * @relayHash 49ab2d90a6ae7ea6087ea4c775c7987e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cde03cdda6c47a2bda97591cb9cd32f5fa989f9cb16f4d9fab8d4d4e1a23f053

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceBlogPostStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type HomeRecentWorkQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
};
export type HomeRecentWorkQuery$data = {
  readonly activity: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly event: {
              readonly eventType: string;
              readonly id: string;
              readonly timestamp: AGG$DateTime;
            };
            readonly id: string;
            readonly object: {
              readonly data: {
                readonly blogStatus?: ConfluenceBlogPostStatus | null | undefined;
                readonly createdAt?: string | null | undefined;
                readonly id?: string;
                readonly links?: {
                  readonly editUi: string | null | undefined;
                  readonly webUi: string | null | undefined;
                } | null | undefined;
                readonly metadata?: {
                  readonly titleEmojiDraft: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                  readonly titleEmojiPublished: {
                    readonly value: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
                readonly pageStatus?: ConfluencePageStatus | null | undefined;
                readonly space?: {
                  readonly alias: string | null | undefined;
                  readonly id: string;
                  readonly key: string | null | undefined;
                  readonly name: string | null | undefined;
                } | null | undefined;
                readonly status?: ConfluenceContentStatus | null | undefined;
                readonly subtype?: ConfluencePageSubType | null | undefined;
                readonly title?: string | null | undefined;
                readonly type?: ConfluenceContentType | null | undefined;
              } | null | undefined;
              readonly id: string;
            };
          };
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type HomeRecentWorkQuery = {
  response: HomeRecentWorkQuery$data;
  variables: HomeRecentWorkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectTypes"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "objectTypes",
            "variableName": "objectTypes"
          },
          {
            "kind": "Literal",
            "name": "products",
            "value": [
              "CONFLUENCE"
            ]
          }
        ],
        "kind": "ObjectValue",
        "name": "arguments"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "rootContainerIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "rootContainerIds"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "AND"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "title"
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v10 = {
  "kind": "ScalarField",
  "name": "webUi"
},
v11 = [
  (v10/*: any*/),
  {
    "kind": "ScalarField",
    "name": "editUi"
  }
],
v12 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v13 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiDraft",
      "plural": false,
      "selections": (v12/*: any*/)
    },
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v12/*: any*/)
    }
  ]
},
v14 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ]
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "alias": "pageStatus",
      "kind": "ScalarField",
      "name": "status"
    },
    (v9/*: any*/),
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v11/*: any*/)
    },
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluencePage"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": "blogStatus",
      "kind": "ScalarField",
      "name": "status"
    },
    (v9/*: any*/),
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v11/*: any*/)
    },
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluenceBlogPost"
},
v17 = {
  "kind": "ScalarField",
  "name": "status"
},
v18 = [
  (v10/*: any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v17/*: any*/),
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v18/*: any*/)
    },
    (v14/*: any*/)
  ],
  "type": "ConfluenceWhiteboard"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v17/*: any*/),
    {
      "concreteType": "ConfluenceDatabaseLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v18/*: any*/)
    },
    (v14/*: any*/)
  ],
  "type": "ConfluenceDatabase"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v17/*: any*/),
    {
      "concreteType": "ConfluenceEmbedLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v18/*: any*/)
    },
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "ConfluenceEmbed"
},
v22 = {
  "concreteType": "ActivityEvent",
  "kind": "LinkedField",
  "name": "event",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "timestamp"
    },
    {
      "kind": "ScalarField",
      "name": "eventType"
    }
  ]
},
v23 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentWorkQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentWorkQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "concreteType": "MyActivity",
            "kind": "LinkedField",
            "name": "myActivity",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "ActivityConnection",
                "kind": "LinkedField",
                "name": "all",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ActivityItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "concreteType": "ActivityObject",
                            "kind": "LinkedField",
                            "name": "object",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                  },
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v23/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v23/*: any*/),
                                    "type": "DevOpsPullRequestDetails"
                                  }
                                ]
                              }
                            ]
                          },
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "49ab2d90a6ae7ea6087ea4c775c7987e",
    "id": "cde03cdda6c47a2bda97591cb9cd32f5fa989f9cb16f4d9fab8d4d4e1a23f053",
    "metadata": {},
    "name": "HomeRecentWorkQuery",
    "operationKind": "query",
    "text": "query HomeRecentWorkQuery($cloudId:ID!,$first:Int,$after:String,$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id}}},event{id,timestamp,eventType}}}}}}}"
  }
};
})();

(node as any).hash = "387eb672f7d767ea7efba42e92a8624f";

export default node;
